<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>정보마당</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">정보마당</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">자주묻는 질문</p>
          <ul class="depth">
            <li><router-link to="/noticelist" title="공지사항">공지사항</router-link></li>
            <li><router-link to="/faqview" title="자주묻는질문">자주묻는질문</router-link></li>
            <li><router-link to="/qnalist" title="묻고 답하기">묻고 답하기</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">자주묻는질문</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ faqCnt }}</span
              >건
            </div>
            <div class="searchBox">
              <div>
                <select id="" v-model="searchCondition" title="검색영역 선택">
                  <option value="1">제목</option>
                  <option value="2">내용</option>
                  <option value="3">제목+내용</option>
                </select>
                <input
                  type="text"
                  title="검색어 입력"
                  placeholder="검색어입력"
                  v-model="searchKeyword"
                  @keyup.enter="getFaqList"
                />
              </div>
              <button type="button" @click="getFaqList" class="btn dkGray">검색</button>
            </div>
          </div>
          <!--//searchArea end -->
          <div v-if="nodata" class="table vertical-table notice">
            <table>
              <tbody>
                <tr class="nodate">
                  <td colspan="6">조회된 데이터가 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <v-expansion-panels v-else class="accordion type02">
            <v-expansion-panel v-for="(item, index) in calData" :key="index">
              <v-expansion-panel-header>
                <div class="title">{{ item.title }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="txt"><div v-html="item.cts"></div></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" :length="numOfPages" @input="getFaqList" />
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
      nodata: true,
      faqCnt: 0,
      searchCondition: 1,
      searchKeyword: '',
      cnt: 0,
      temp: '',
    };
  },

  mounted() {
    this.getFaqList();
  },

  methods: {
    async getFaqList() {
      if (this.cnt == 0) {
        if (this.searchKeyword != '') {
          this.cnt = 1;
          this.curPageNum = 1;
        }
      } else {
        if (this.searchKeyword != this.temp) {
          this.curPageNum = 1;
          if (this.searchKeyword == '') {
            this.cnt = 0;
          } else {
            this.cnt = 1;
          }
        }
      }
      this.temp = this.searchKeyword;
      const res = await axios('get', '/api/board/faq/list.json', {
        searchCondition: this.searchCondition,
        searchKeyword: this.searchKeyword,
        bbsCd: 'faq',
        recordCountPerPage: this.dataPerPage,
        firstIndex: (this.curPageNum - 1) * this.dataPerPage,
      });
      const data = res.data.boardList;
      if (!data || data.length > 0) {
        this.faqCnt = res.data.boardTotalCount;
        this.listData = res.data.boardList;
        this.nodata = this.listData.length > 0 ? false : true;
      } else {
        this.listData = [];
        this.nodata = true;
      }
    },

    view(atclId) {
      this.$router.push({
        path: 'faqview',
        query: { atclId: atclId },
      });
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      return this.listData.slice(this.startOffset, this.endOffset);
    },
  },
};
</script>
